import { ClearanceApproval } from "@/models/clearance-approval.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";
import { InvoiceLine } from "@/models/invoice-line.entity";
import clearanceApprovalRequestService from "@/services/mrfiktiv/services/clearance-approval-request.service";
import { $t } from "@/lib/utility/t";

export class ClearanceApprovalFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.CLEARANCE_APPROVAL;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.CLEARANCE_APPROVAL, async () => {
      const response = await clearanceApprovalRequestService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      const request = new ClearanceApproval(response);

      // Add default first position to request
      if (!request.lineItems || !request.lineItems.length) {
        request.lineItems = [
          new InvoiceLine({
            title: $t("clearanceApproval.defaultPosition").toString()
          })
        ];
      }

      return request;
    });
  }
}
